import React, { useEffect, useState } from 'react';
import axios from 'axios';
import $ from 'jquery';
import Spinner from '../Spinner';
import api from '../../api/axiosInstance';
function Users() {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [editingUserId, setEditingUserId] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isDesigner, setIsDesigner] = useState(false);
    const [isApprover, setIsApprover] = useState(false);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                debugger;
                const response = await api.get('/Administration/ViewUsers');
                setUsers(response.data);
            } catch (error) {
                console.error("Error fetching users:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchUsers();
    }, []);

    useEffect(() => {
        if (!loading && window.$) {
            window.$('#example1').DataTable({
                responsive: true,
                autoWidth: false,
                searching: true,
                ordering: true,
                pageLength: 10,
                lengthChange: false,
                paging: true,
                info: true,
            });
        }
    }, [loading]);

    const handleEdit = async (id) => {
        setEditingUserId(id);
        const user = await api.get(`/Administration/ViewUser/${id}`);
   
        setIsAdmin(user.data.isAdmin);
        setIsDesigner(user.data.isFormDesigner);
        setIsApprover(user.data.isFormApprover);

    };

    const handleSave = () => {
        $.confirm({
            title: 'Confirm Save',
            content: 'Do you really want to save the changes for this user?',
            buttons: {
                cancel: {
                    text: 'Cancel',
                    btnClass: 'btn-red',
                    action: function () { }
                },
                confirm: {
                    text: 'Yes, Save it!',
                    btnClass: 'btn-green',
                    action: async function () {
                        try {
                            const userId = editingUserId; // Ensure you have the selected user ID
                            const response = await api.put(
                                `/Administration/SaveUser?userId=${userId}&isAdmin=${isAdmin}&isApprover=${isApprover}&isDesigner=${isDesigner}`,
                                null,
                                {
                                    headers: {
                                        'Content-Type': 'application/json',
                                    },
                                }
                            );
    
                            $.alert({
                                title: 'Success!',
                                content: response.data,
                                type: 'green',
                                buttons: {
                                    okay: {
                                        text: 'Ok',
                                        btnClass: 'btn-green',
                                        action: function () {
                                            // Refresh users after saving
                                            api.get('/Administration/ViewUsers')
                                                .then(fetchResponse => {
                                                    setUsers(fetchResponse.data);
                                                });
                                        }
                                    }
                                }
                            });
                        } catch (error) {
                            if (error.response && error.response.status === 409) {
                                $.alert({
                                    title: 'Error!',
                                    content: error.response.data,
                                    type: 'red',
                                });
                                console.log(error);
                            } else {
                                $.alert({
                                    title: 'Error!',
                                    content: 'Error saving user details.',
                                    type: 'red',
                                });
                                console.log(error);
                            }
                        } finally {
                            const modal = document.getElementById('modal-default');
                            modal.style.display = 'none'; // Close the modal
                            const backdrop = document.querySelector('.modal-backdrop');
                            if (backdrop) {
                                backdrop.remove();
                            }
                        }
                    }
                }
            }
        });
    };
    

    const handleUserStatusChange = async (id, isActive) => {
        $.confirm({
            title: isActive ? 'Confirm Activating' : 'Confirm Deactivating',
            content: `Do you really want to ${isActive ? 'Activate' : 'Deactivate'} this user?`,
            buttons: {
                cancel: {
                    text: 'Cancel',
                    btnClass: 'btn-red',
                    action: function () { }
                },
                confirm: {
                    text: isActive ? 'Yes, Activate it!' : 'Yes, Deactivate it!',
                    btnClass: 'btn-green',
                    action: async function () {
                        try {
                            const response = await api.post(
                                `/Administration/ChangeUserStatus?id=${id}&isActive=${isActive}`,
                                null,
                                {
                                    headers: {
                                        'Content-Type': 'application/json'
                                    }
                                }
                            );

                            $.alert({
                                title: 'Success!',
                                content: response.data,
                                type: 'green',
                                buttons: {
                                    okay: {
                                        text: 'Ok',
                                        btnClass: 'btn-green',
                                        action: function () {
                                            api.get('/Administration/ViewUsers')
                                                .then(fetchResponse => {
                                                    setUsers(fetchResponse.data);
                                                });
                                        }
                                    }
                                }
                            });
                            
                        } catch (error) {
                            if (error.response && error.response.status === 409) {
                                $.alert({
                                    title: 'Error!',
                                    content: error.response.data,
                                    type: 'red',
                                });
                            } else {
                                $.alert({
                                    title: 'Error!',
                                    content: `Error ${isActive ? 'Activating' : 'Deactivating'} User`,
                                    type: 'red',
                                });
                            }
                        }
                    }
                }
            }
        });
    };

    return (
        <div>
            <div className="card card-success" style={{ marginTop: '0px' }}>
                <div className="card-header" style={{ display: 'flex', flexDirection: 'column' }}>
                    <h3 className="card-title">Users</h3>
                </div>
                <div className="card-body">
                    {loading ? (
                        <Spinner /> // Use the Spinner component here
                    ) : (
                        <div className="col-sm-12">
                            <table id="example1" className="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Is Admin?</th>
                                        <th>Is Designer?</th>
                                        <th>Is Approver?</th>
                                        <th>Has Portal Access?</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {users.map(user => (
                                        <tr key={user.id}>
                                            <td>{user.name}</td>
                                            <td>{user.email}</td>
                                            <td>{user.isAdmin ? 'Yes' : 'No'}</td>
                                            <td>{user.isFormDesigner ? 'Yes' : 'No'}</td>
                                            <td>{user.isFormApprover ? 'Yes' : 'No'}</td>
                                            <td>{user.hasPortalAccess ? 'Yes' : 'No'}</td>
                                            <td>
                                                <button
                                                    className='btn btn-xs btn-primary'
                                                    onClick={() => handleEdit(user.id)}
                                                    title='Edit'
                                                     data-toggle="modal"
                                                     data-target="#modal-default"
                                                >
                                                    <i className='fa fa-edit'></i>
                                                </button>
                                                &nbsp;&nbsp;&nbsp;
                                                {user.hasPortalAccess ? (
                                                    <button
                                                        className='btn btn-xs btn-danger'
                                                        onClick={() => handleUserStatusChange(user.id, false)}
                                                        title='Deactivate'
                                                    >
                                                        <i className='fa fa-ban'></i> Deactivate
                                                    </button>
                                                ) : (
                                                    <button
                                                        className='btn btn-xs btn-success'
                                                        onClick={() => handleUserStatusChange(user.id, true)}
                                                        title='Activate'
                                                    >
                                                        <i className='fa fa-check'></i> Activate
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Is Admin?</th>
                                        <th>Is Designer?</th>
                                        <th>Is Approver?</th>
                                        <th>Has Portal Access?</th>
                                        <th>Action</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    )}
                </div>
            </div>

            {/* Modal for Editing User */}
            <div className="modal fade" id="modal-default" tabIndex="-1" role="dialog" aria-labelledby="modal-default-label" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Edit User</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            
                            <div className='form-group'>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={isAdmin}
                                        onChange={() => setIsAdmin(!isAdmin)}
                                    />
                                    Is Admin?
                                </label>
                            </div>
                            <div className='form-group'>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={isDesigner}
                                        onChange={() => setIsDesigner(!isDesigner)}
                                    />
                                    Is Designer?
                                </label>
                            </div>
                            <div className='form-group'>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={isApprover}
                                        onChange={() => setIsApprover(!isApprover)}
                                    />
                                    Is Approver?
                                </label>
                            </div>
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                            <button type="button" className="btn btn-primary" onClick={handleSave}>Save changes</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Users;
